<template>
  <div id="app">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <!-- Navigation -->
    <div class="jumbotron ban" style="margin-bottom:0px;padding-top:10px;padding-bottom: 30px;">
      <h1 class="titlelogo">{{user}}</h1>
      <span style="font-size:30px;color:#666;">{{fonction}}</span>
    </div>
    <nav class="navbar navbar-expand-md navbar-dark bg-dark sticky-top">
      <img class="logo" v-bind:src="logoImg">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar-nav mr-auto">
          <li class="nav-item"><a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show" href="#" title="Accueil">
              <router-link to="/">
                <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-house-fill" fill="orange"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M8 3.293l6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z" />
                  <path fill-rule="evenodd"
                    d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z" />
                </svg>
                <br />
                <span style="color:#d5d5d5">Accueil</span>
              </router-link>
            </a></li>
          <li class="nav-item"><a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show" href="#" title="Galerie">
              <router-link to="/galerie">
                <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-images" fill="orange"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M12.002 4h-10a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1zm-10-1a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-10zm4 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                  <path fill-rule="evenodd"
                    d="M4 2h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1z" />
                </svg>
                <br />
                <span style="color:#d5d5d5">Galerie</span>
              </router-link>
            </a></li>
          <li class="nav-item"><a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show" href="#" title="Expositions">
              <router-link to="/exposition">
                <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-globe2" fill="orange"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539a8.372 8.372 0 0 1-1.198-.49 7.01 7.01 0 0 1 2.276-1.52 6.7 6.7 0 0 0-.597.932 8.854 8.854 0 0 0-.48 1.079zM3.509 7.5H1.017A6.964 6.964 0 0 1 2.38 3.825c.47.258.995.482 1.565.667A13.4 13.4 0 0 0 3.508 7.5zm1.4-2.741c.808.187 1.681.301 2.591.332V7.5H4.51c.035-.987.176-1.914.399-2.741zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5H7.5v2.409c-.91.03-1.783.145-2.591.332a12.343 12.343 0 0 1-.4-2.741zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696A12.63 12.63 0 0 1 7.5 11.91v3.014c-.67-.204-1.335-.82-1.887-1.855a7.776 7.776 0 0 1-.395-.872zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964a9.083 9.083 0 0 0-1.565.667A6.963 6.963 0 0 1 1.018 8.5h2.49a13.36 13.36 0 0 0 .437 3.008zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909c.81.03 1.577.13 2.282.287-.12.312-.252.604-.395.872-.552 1.035-1.218 1.65-1.887 1.855V11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5h-2.49a13.361 13.361 0 0 0-.437-3.008 9.123 9.123 0 0 0 1.565-.667A6.963 6.963 0 0 1 14.982 7.5zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343c-.705.157-1.473.257-2.282.287V1.077c.67.204 1.335.82 1.887 1.855.143.268.276.56.395.872z" />
                </svg>
                <br />
                <span style="color:#d5d5d5">Expositions</span>
              </router-link>
            </a></li>
          <li class="nav-item"><a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show" href="#" title="Reseaux">
              <router-link to="/reseaux">
                <svg width="3em" height="3em" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"
                  fill="orange">
                  <path
                    d="M57.378,0.001H3.352C1.502,0.001,0,1.5,0,3.353v54.026c0,1.853,1.502,3.354,3.352,3.354h29.086V37.214h-7.914v-9.167h7.914
		v-6.76c0-7.843,4.789-12.116,11.787-12.116c3.355,0,6.232,0.251,7.071,0.36v8.198l-4.854,0.002c-3.805,0-4.539,1.809-4.539,4.462
		v5.851h9.078l-1.187,9.166h-7.892v23.52h15.475c1.852,0,3.355-1.503,3.355-3.351V3.351C60.731,1.5,59.23,0.001,57.378,0.001z" />
                </svg>
                <br />
                <span style="color:#d5d5d5">Réseaux</span>
              </router-link>
            </a></li>
        </ul>
      </div>

    </nav>
    <hr />
      <!-- Contenu -->
    <div>
      <router-view></router-view>
    </div>
    <hr />
    <!-- Footer -->
    <footer class="bg-dark">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-6">
            <span>Comment me joindre ?</span>
            <hr class="light-100" />
            <small>: 0247470083 / 0687477363 | @ : bernardfievre@wanadoo.fr <br />
              Siège :Bernard Fièvre, 2 rue du Mûrier 37000 Tours </small>
          </div>
          <div class="col-md-6">
            <span>Réprésentant légal</span>
            <hr class="light-100" />
            <small>Toutes les oeuvres sont la propriété de <b>M. Bernard Fièvre</b>,
              toute reproduction est strictement interdite.<br>
              Photos : &copy;Chris lec 2015 - <a href="http://www.chrislec.fr" target="_blank">chrislec.fr</a>
            </small></div>
          <div class="col-md-12">
            <hr class="light-100" />
            <small>&copy;Bernard Fièvre</small>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import VueRouter from 'vue-router';
import Home from './components/Home.vue';
import Reseaux from './components/Reseaux.vue';
import Galerie from './components/Galerie.vue';
import Expos from './components/Expos.vue';
import Vuetify from 'vuetify';
import logoImg from '../img/logo.png';
import 'vuetify/dist/vuetify.min.css';

// router
const routes = [
  { path: '/', component: Home , name: 'Home'},
  { path: '/galerie', component: Galerie , name: 'Galerie'},
  { path: '/exposition', component: Expos , name: 'Expos' },
  { path: '/reseaux', component: Reseaux , name: 'Reseaux'}
];

const router = new VueRouter({
  routes
});

export default {
  name: 'vue',
  router,
  vuetify: new Vuetify(),
  data:() =>{
    return{
      user: "BERNARD FIÈVRE",
      fonction:"Peintre monochromatique français",
      logoImg,
    }
  },
}
</script>

<style>
  .ban
  {
    background-image: url('../img/acceuil.png');
    background-repeat: round;
  }
  .titlelogo
  {
    font-family:Castellar;
    /*font-family:Algerian;*/
    color:#666;
    font-size:50px;

    padding-top:50px;
  }
  .logo{
  width: 5em;
  height: 5em;
  margin-right: 1em;
}
/*--- Fixed Background Image --*/
figure {
  position: relative;
  width: 100%;
  height: 60%;
  margin: 0!important;
}
.fixed-wrap {
  clip: rect(0, auto, auto, 0);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/*--- Bootstrap Padding Fix --*/
[class*="col-"] {
    padding: 1rem;
}

footer{
  color: #d5d5d5;
}
hr.light-75{
  border-top: 1px solid #d5d5d5;
  width: 75%;
  margin-top: .10rem;
  margin-bottom: 1rem;
  text-align: center;
}
footer a{
  color: rgb(213, 213, 213);
}
hr.light-100{
  border-top: 1px solid #d5d5d5;
  width: 100%;
  margin-top: .10rem;
  margin-bottom: 1rem;
}
hr.light-50{
  border-top: 1px solid #d5d5d5;
  width: 50%;
  margin-top: .8rem;
  margin-bottom: 1rem;
  text-align: center;
}
footer a{
  color: #d5d5d5;
}
</style>
